import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'cliente-configuracao');

const parametrizacaoClienteActions = {
  buscar: { method: 'GET', url: `${basePath}/{chave}` },
  salvar: { method: 'PUT', url: `${basePath}/{chave}` },
  buscarTodas: { method: 'GET', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, parametrizacaoClienteActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/parametrizacao-cliente.js